import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

export function billGetList(data) {
  return request({
    url: '/admin/flow_list/getlist',
    method: 'get',
    params: data
  })
}

export function billWithdraw(data) {
  return request({
    url: '/admin/flow_list/uoDo',
    method: 'post',
    data
  })
}

export function billAdd(data) {
  return request({
    url: '/admin/company_account/addonMoney',
    method: 'post',
    data
  })
}

export function flowRemarkUp(data) {
  return request({
    url: '/admin/flow_list/remarkUp',
    method: 'post',
    data
  })
}

export function moveToMoney(data) {
  return request({
    url: '/admin/company_account/moveToMoney',
    method: 'post',
    data
  })
}

export function supplierToMoney(data) {
  return request({
    url: '/admin/supplier/transfer',
    method: 'post',
    data
  })
}

export function billTotal(data) {
  return request({
    url: '/admin/flow_list/total',
    method: 'get',
    params: data
  })
}

export function billFlowTotal(data) {
  return request({
    url: '/admin/flow_list/getFlowTotal',
    method: 'get',
    params: data
  })
}

export function checkFlow(data) {
  return request({
    url: '/admin/flow_list/checkFlow',
    method: 'get',
    params: data
  })
}

 


// WEBPACK FOOTER //
// ./src/api/bill.js